import React from 'react'
import "./contact.scss"
import Swal from 'sweetalert2';
import { useFormik } from 'formik';
import focused from "../../assets/Images/side-bg-image4.svg"
import { ContactSchema, ContactValue } from "./ContactSchema";

export default function Contact() {

    async function handleForm(values) {
        console.log(values);
        Swal.fire({
            title: "Thank you for contacting!",
            text: "We will get in touch with you soon.",
            icon: "success",
            confirmButtonText: "OK",
        });
    }

    const {
        values,
        errors,
        dirty,
        touched,
        handleBlur,
        handleChange,
        setValues,
        setFieldValue,
        setFieldTouched,
        setTouched,
        handleSubmit,
        isSubmitting,
    } = useFormik({
        initialValues: ContactValue,
        validationSchema: ContactSchema,
        onSubmit: handleForm,
        enableReinitialize: true,
    });

    return (
        <section className="Contact_section" id="contact">
            <div className="container">
                <div className="row align-items-center">
                    <div className='col-lg-12 mb-5'>
                        <div className='form-title-div'>
                            <h2 className='section-heading'>contact us</h2>
                            <p className='section-peragrph text-center'> For inquiries or assisance, connect with our dedicated support team.</p>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6">

                        <div className='Form_Div'>
                            <div className='form-inputs-div' >
                                <form onSubmit={handleSubmit}>
                                    <div className='row'>
                                        <div className='col-sm-6 mb-3'>
                                            <input
                                                autoComplete="off"
                                                id="name"
                                                name="name"
                                                placeholder="Name"
                                                value={values.name}

                                                type="text"
                                                className={`form-control ${errors.name && touched.name
                                                    ? "is-invalid"
                                                    : !errors.name && dirty.valueOf()
                                                        ? "is-valid"
                                                        : ""
                                                    }`}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                            {errors.name && touched.name ? (
                                                <div className="text-danger">{errors.name}</div>
                                            ) : null}

                                        </div>
                                        <div className='col-sm-6 mb-3'>
                                            <input
                                                autoComplete="off"
                                                id="phoneNo"
                                                name="phoneNo"
                                                placeholder="Phone No"
                                                value={values.phoneNo}
                                                type="text"
                                                className={`form-control ${errors.phoneNo && touched.phoneNo
                                                    ? "is-invalid"
                                                    : !errors.phoneNo && dirty.valueOf()
                                                        ? "is-valid"
                                                        : ""
                                                    }`}
                                                maxLength="10"
                                                minLength="10"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                            {errors.phoneNo && touched.phoneNo ? (
                                                <div className="text-danger">{errors.phoneNo}</div>
                                            ) : null}

                                        </div>
                                        <div className='col-sm-6 mb-3'>
                                            <input
                                                autoComplete="off"
                                                id="EmailId"
                                                name="EmailId"
                                                placeholder="Email"
                                                type="email"
                                                value={values.EmailId}
                                                className={`form-control ${errors.EmailId && touched.EmailId
                                                    ? "is-invalid"
                                                    : !errors.EmailId && dirty.valueOf()
                                                        ? "is-valid"
                                                        : ""
                                                    }`}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                            {errors.EmailId && touched.EmailId && (
                                                <div className="invalid-feedback">
                                                    {errors.EmailId}
                                                </div>
                                            )}
                                        </div>
                                        <div className='col-sm-6 mb-3'>
                                            <input
                                                type="text"
                                                id="Address"
                                                name="Address"
                                                autoComplete="off"
                                                placeholder="Shop Address"
                                                value={values.Address}
                                                className={`form-control ${errors.Address && touched.Address
                                                    ? "is-invalid"
                                                    : !errors.Address && dirty.valueOf()
                                                        ? "is-valid"
                                                        : ""
                                                    }`}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            ></input>
                                            {errors.Address && touched.Address && (
                                                <div className="invalid-feedback">
                                                    {errors.Address}
                                                </div>
                                            )}

                                        </div>
                                        <div className='col-sm-12 mb-3'>
                                            <textarea
                                                autoComplete="off"
                                                style={{
                                                    height: "100px",
                                                }}
                                                name="Message"
                                                placeholder="Message"
                                                id="Message"
                                                value={values.Message}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                className={`form-control ${errors.Message && touched.Message
                                                    ? "is-invalid"
                                                    : !errors.Message && dirty.valueOf()
                                                        ? "is-valid"
                                                        : ""
                                                    }`}
                                            ></textarea>
                                            {errors.Message && touched.Message && (
                                                <div className="invalid-feedback">{errors.Message}</div>
                                            )}
                                        </div>
                                        <div className='col-sm-12 mb-3'>
                                            <button type='submit' disabled={isSubmitting} className='form-control register-btn' > Submit</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6 text-center" data-aos="flip-up">
                        <img
                            src={focused}
                            className="img-fluid girl-comunity "
                            alt="community image"
                            style={{ width: "450px", height: "400px", objectFit: "cover" }}
                        />
                    </div>
                </div>
            </div>
        </section>
    )
}
